export const pageName = {
  HOME_PAGE: "HOME_PAGE",
  FLIGHT_SEARCH_LIST_PAGE: "FLIGHT_SEARCH_LIST_PAGE",
  RETRIEVE_BOOKING_PAGE: "RETRIEVE_BOOKING_PAGE",
  ADD_PAX_DETAILS: "ADD_PAX_DETAILS",
  ADDONS: "ADDONS_PAGE",
  SEAT_SELECTION: "SEAT_SELECTION",
  BOOKING_SUMMARY: "BOOKING_SUMMARY",
  LOGIN_FLOW: "LOGIN_FLOW",
  BOOKING_FLOW: "BOOKING_FLOW",
  HEALTH_DECLARATION: "HEALTH_DECLARATION",
  DANGEROUS_GOOD: "DANGEROUS_GOOD",
  CANCEL_BOOKING: "CANCEL_BOOKING",
  CHECK_IN_SUMMARY: "CHECK_IN_SUMMARY",
  CHECK_IN_PAYMENT_SUMMARY: "CHECK_IN_PAYMENT_SUMMARY",
  TRAVEL_CERTIFICATE: "TRAVEL_CERTIFICATE"
};

export const actionType = {
  CLICK: "CLICK",
  PAGE_VIEW: "PAGE_VIEW",
  SYSTEM_FLOW: "SYSTEM_FLOW",
  SHOWING_APPLICATION_ERROR_MESSAGE: "SHOWING_APPLICATION_ERROR_MESSAGE"
};

export const section = {
  AUTH: "AUTH_SECTION",
  ADDONS: "ADDONS_SECTION",
  ADD_PAX_DETAILS: "ADD_PAX_DETAILS",
  SEARCH_FLIGHT: "SEARCH_FLIGHT",
  FLIGHT_BOOKING_PANEL: "FLIGHT_BOOKING_PANEL",
  BOOKING_SUMMARY: "BOOKING_SUMMARY",
  CALENDER_STRIP: "CALENDER_STRIP",
  MODIFY_SEARCH: "MODIFY_SEARCH",
  FLIGHT_SELECT_BUTTON: "FLIGHT_SELECT_BUTTON",
  CHANGE_BOOKING_MODAL: "CHANGE_BOOKING_MODAL",
  SEAT_SELECTION: "SEAT_SELECTION",
  LOGIN_FLOW: "LOGIN_FLOW",
  USER_DETAILS_FORM: "USER_DETAILS_FORM",
  DANGEROURS_GOOD_AGREE: "DANGEROURS_GOOD_AGREE",
  CHECK_IN_PAYMENT_PROCEED: "CHECK_IN_PAYMENT_PROCEED",
  CANCEL_BOOKING_POPUP: "CANCEL_BOOKING_POPUP",
  SUBSCRIPTION: "SUBSCRIPTION",
  HEADER: "HEADER",
  TRAVEL_CERTIFICATE: "TRAVEL_CERTIFICATE"
};

export const eventName = {
  FLIGHT_SEARCH: "FB_FlightSearched",
  FLIGHT_SELECT: "Flight_Selected",
  BOOKING_INITIATED: "Flight_booking_initiated",
  ADD_PAX_DETAILS: "Flight_GuestDetails_Submitted",
  FC_GuestDetails_Submitted: "FC_GuestDetails_Submitted",
  SIGNUP_SUCCESS: "SignUp_Successful",
  LOGIN_SUCCESS: "Login_Successful",
  ADDONS_SELECTED: "Flight_AddonsSelected",
  ADDONS_SELECTED_GA4: "FC_FlightSummary",
  ADDONS_SKIPED: "Flight_SkipAddon",
  FLIGHT_CHECKIN_ADDONS_SELECTED: "FC_AddonsSelected",

  FLIGHT_SEAT_SELECTED: "Flight_SeatSelected",
  FLIGHT_CHECKIN_SEAT_SELECTED: "FC_SeatSelected",
  PAYMENT_INITIATED: "Flight_Payment_initiated",
  PAYMENT_FAILED: "FB_BookingFailed",
  BOOKING_SUCCESSFUL: "FB_Successful",
  LOGOUT_SUCCESS: "Logout_Successful",
  CHANGE_BOOKING: "Flight_change_booking_initiated",
  FLIGHT_LISTING: "Flight_list",
  CHECKIN_INIT: "FC_PNRDetails_Submit",
  CHECKIN_ACCEPT_NO_DANGEROURS_GOOD: "FC_Dangerous_Goods_Acknowledgement",
  CHECKIN_SUCCESSFULL: "FC_Successful",
  CHECKIN_FAILED: "CHECKIN_FAILED",
  CHECKIN_SUCCESSFULL_GA4: "MB_CheckInSuccessful",
  CANCELED_BOOKING: "MB_FlightCancelled",
  CANCELED_BOOKING_GA4: "MB_BookingCancelled",
  RETRIVE_BOOKING_WITH_PNR: "RETRIVE_BOOKING_WITH_PNR",
  EXCESS_BAGGAGE_INIT: "Excess_Baggage_Initiated",
  CAFE_AKASA: "CafeAkasa",
  SELECT_YOUR_SEAT: "SelectYourSeat",
  PRIORITY_CHECKIN: "PriorityCheckin",
  BOARD_FIRST: "BoardFirst",
  NEWS_LETTER_SIGNUP: "NewsletterSignUp",
  BOOKING_CANCELED: "MB_FlightCancelled",
  BOOKING_CHANGED: "MB_BookingChanged",
  APPLICATION_EXCEPTION_ERROR: "APPLICATION_EXCEPTION_ERROR",
  MANAGE_BOOKING_VIEW: "MB_VIEW",
  MANAGE_BOOKING_CHECKIN_CLICKED: "MB_CHECKIN_CLICKED",
  MANAGE_BOOKING_CHECKIN_VIEW_ERROR: "MB_CHECKIN_VIEW_ERROR",
  MANAGE_BOOKING_CHECKIN_VIEW_POPUP_SUCCESS: "MB_CHECKIN_VIEW_POPUP_SUCCESS",
  MANAGE_BOOKING_CHECKIN_POPUP_CHECKIN_CLICKED: "MB_CHECKIN_VIEW_POPUP_CHECKIN_CLICKED",
  MANAGE_BOOKING_CHECKIN_POPUP_CHECKIN_CLICKED_GA4: "FC_CheckIn",
  MANAGE_BOOKING_CHECKIN_POPUP_CHECKIN_CLICKED_ERROR: "MB_CHECKIN_VIEW_POPUP_CHECKIN_CLICKED_ERROR",
  FC_SELECT_ALL_PAX_FOR_CHECKIN: "FC_SELECT_ALL_PAX_FOR_CHECKIN",
  FC_SELECT_ONE_PAX_FOR_CHECKIN: "FC_SELECT_ONE_PAX_FOR_CHECKIN",
  FC_AUTO_SEAT_ASSIGN_FOR_CHECKIN: "FC_AUTO_SEAT_ASSIGN_FOR_CHECKIN",
  FC_CLICKED_ON_SELECT_ADDONS: "FC_CLICKED_ON_SELECT_ADDONS",
  CHECKIN_RETRIVE_BOOKING: "CHECKIN_RETRIVE_BOOKING",
  CATEGORY_VIEW: "category_viewed",
  BOOKING_CANCEL_INITIATED: "Booking_Cancelled_Initiated",
  BOOKING_CHANGE_INITIATED: "Cb_Initiated",
  BOOKING_CONTACT_DETAILS_UPDATED: "ProfileUpdated",
  BOOKING_CONTACT_DETAILS_UPDATED_GA4: "MB_ContactDetails_Updated",
  MANAGE_BOOKING_ADDONS_ADDED: "MB_BookingUpdate",
  COMPLIMENTARY_MEAL_POPUP_CONFIRM_CLICKED: "COMPLIMENTARY_MEAL_POPUP_CONFIRM_CLICKED",
  MANAGE_BOOKING_ADDONS_ADDED_GA4: "MB_AddonsPurchased",
  MANAGE_BOOKING_PNR_DETAILS: "MB_PNRDetails_Submit",
  FLIGHT_SEARCH_MODIFY: "FB_FlightSearchModified",
  MANAGE_BOOKING_ADDONS_CLICKED: "MB_AddonsClicked",
  MANAGE_BOOKING_ETICKET_CLICKED: "MB_EticketSelected",
  MANAGE_BOOKING_BOARDING_PASSED_CLICKED: "MB_BoardingPassSelected",
  MANAGE_BOOKING_CALCELLATION_POLICY_CLICKED: "MB_CancellationPolicy_Open",
  FC_CHECK_IN_API_CALLING: "FC_CHECK_IN_API_CALLING",
  FC_CHECK_IN_API_RESPONSE: "FC_CHECK_IN_API_RESPONSE",
  FC_CHECK_IN_API_RESPONDED_FAILED: "FC_CHECK_IN_API_RESPONDED_FAILED",
  FC_CHECK_IN_API_RESPONDED_SUCCESS: "FC_CHECK_IN_API_RESPONDED_SUCCESS",
  EXCEPTION: "EXCEPTION",
  FLIGHT_SEAT_SELECTED_FAILED: "FLIGHT_SEAT_SELECTED_FAILED",

  PROMO_NUDGE_CLICKED: "Promo Nudge Clicked",
  SORT_FILTER_APPLIED: "Sort Filter Applied",
  FLEXI_BANNER: "Flexi Conversion Banner Clicked",

  BOOKING_SUMMARY: "Checkout Step 4: Summary",
  PAYMENT :"Checkout Step 5 : Payment",

  CHECKIN_PAYMENT_INITIATED: "Checkin Payment initiated",
  VIEW_ALL_OFFER_CLICKED: "Promo Code Applied",
  BUSINESS_TRIP_DETAILS_ADDED: "Business Trip Details Added",
  OTP_VALIDATION_SUCCESS: "Otp_Validated_Successful",
  CHECKIN_ADDONS: "Check-In Add ons",
  
  ORDER_API_CALLING: "ORDER_API_CALLING",
  ORDER_API_RESPONDED_FAILED: "ORDER_API_RESPONDED_FAILED",
  ORDER_API_RESPONDED_SUCCESS: "ORDER_API_RESPONDED_SUCCESS",

};

export const pageSection = {
  CHECK_IN: "Check-In",
  MANAGE_BOOKING: "Manage-booking",
  NEW_BOOKING: "Flight-booking",
  TRAVEL_CERTIFICATE: "Travel-Certificate"
};